import getRoles from './role';
const ORGANIZATION_TYPE_ROLE = 2;

const getOrganizationTypes = async (lng: string) => {
    return await getRoles(lng, ORGANIZATION_TYPE_ROLE);
};

export default getOrganizationTypes;
